<div class="error-wrapper">
  <div class="error">
    <div class="logo__error">
      <img src="assets/images/logo.svg">
    </div>

    <div class="error__inner">
      <div class="icon-wrapper">
        <i class="fal fa-exclamation-circle" style="font-size: 65px;"></i>
      </div>
      <h1></h1>
      <p>End session, Please wait...</p>
      <!-- <p>Your session has been expired, Click Logout to redirect login page</p> -->
      <!-- <button (click)="endsession()" style="background-color: #344054;
      color: white;
      padding: 12px;
      border-radius: 6px;">Logout</button> -->
    </div>
  </div>
</div>
